import { yupResolver } from "@hookform/resolvers/yup";
import { UserContext } from "context/UserContext";
import { usePostAlterarSenha } from "hooks/usuario/usePostAlterarSenha";
import { ReactNode, useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FaCheck, FaTimes } from "react-icons/fa";
import CustomButton from "shared/components/button/CustomButton";
import TextInput from "shared/components/input/TextInput";
import CustomModal from "shared/components/modal/CustomModal";
import showAlert from "shared/util/functions/alert/showAlert";
import { AlterarSenhaSchema } from "shared/yup/schemas/AlterarSenhaSchema";
import { RequestAlterarSenha } from "types/request/RequestAlterarSenha";

interface ModalRedefinirSenhaUsuarioProps {
  showModal: boolean;
  onCloseModal: () => void;
}

interface AlterarSenha {
  senhaAntiga: string;
  novaSenha: string;
  confirmarSenha: string;
}

export const ModalRedefinirSenhaUsuario = (props: ModalRedefinirSenhaUsuarioProps) => {
  const { register, control, reset, handleSubmit, setValue, setError, formState } =
    useForm<AlterarSenha>({
      resolver: yupResolver<AlterarSenha>(AlterarSenhaSchema),
    });
  const { usuarioLogado } = useContext(UserContext);

  const fecharModal = () => {
    reset();
    props.onCloseModal();
  };
  const { mutate } = usePostAlterarSenha(setError, fecharModal);

  const closeModal = () => {
    if (formState.isDirty) {
      showAlert({
        texto:
          "Existem alterações que não foram salvas na tela. Tem certeza de que deseja sair sem salvar?",
        tipoAlerta: "CONFIRMAR_CANCELAR_ALERT",
        onConfirm: () => fecharModal(),
      });
    } else {
      fecharModal();
    }
  };

  const alterarSenha = (form: AlterarSenha) => {
    mutate({
      id: usuarioLogado.id,
      email: usuarioLogado.clienteGroupEmail,
      senhaAnterior: form.senhaAntiga,
      password: form.novaSenha,
      confirmPassword: form.confirmarSenha,
    } as RequestAlterarSenha);
  };

  const renderFooterModal = (): ReactNode => {
    return (
      <Row>
        <Col className="d-flex justify-content-end p-0">
          <CustomButton
            id="btn-cancelar-modal-alterar-senha"
            label="Cancelar"
            leftIcon={FaTimes}
            onClick={() => closeModal()}
            variant="danger-alt"
            className="me-2"
          />
          <CustomButton
            id="btn-cancelar-modal-alterar-senha"
            label="Salvar"
            leftIcon={FaCheck}
            onClick={handleSubmit(alterarSenha)}
            variant="primary"
            className="ps-4 pe-4"
          />
        </Col>
      </Row>
    );
  };

  return (
    <CustomModal
      titulo="Alterar Senha"
      size="sm"
      showModal={props.showModal}
      tipoModal="MODAL_LATERAL"
      fecharModalAoClicarFora={!formState.isDirty}
      onCloseModal={() => closeModal()}
      customFooter={renderFooterModal()}
    >
      <Row className="mb-2">
        <Col xs={6}>
          <h3 className="sub-titulo">Nome</h3>
          <div>{usuarioLogado.clienteGroup}</div>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col xs={6}>
          <h3 className="sub-titulo">E-mail</h3>
          <div>{usuarioLogado.clienteGroupEmail}</div>
        </Col>
      </Row>

      <TextInput
        className="mb-2"
        control={control}
        name="senhaAntiga"
        id="senhaAntiga"
        register={register}
        label="Senha antiga"
        placeholder="Digite sua senha antiga"
        usarValidacaoParaFormulario
        setValue={setValue}
        isPassword
      />

      <TextInput
        className="mb-2"
        control={control}
        name="novaSenha"
        id="novaSenha"
        register={register}
        label="Nova senha"
        placeholder="Digite sua nova senha"
        usarValidacaoParaFormulario
        setValue={setValue}
        isPassword
      />

      <TextInput
        className="mb-2"
        control={control}
        name="confirmarSenha"
        id="confirmarSenha"
        register={register}
        label="Repitir senha"
        placeholder="Repita sua nova senha"
        usarValidacaoParaFormulario
        setValue={setValue}
        isPassword
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSubmit(alterarSenha)();
          }
        }}
      />
    </CustomModal>
  );
};
